import { useTranslation } from "react-i18next";
import { MapPin, Phone, Mail, Globe } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Qianqin
            </h3>
            <p className="text-gray-400 max-w-md">
              {t("about.companyName")}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              Contact
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <div>
                  <p>{t("about.manager")}: {t("about.managerPhone")}</p>
                  <p>{t("about.mrJake")}: {t("about.mrJakePhone1")} / {t("about.mrJakePhone2")}</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <div>
                  <a href={`mailto:${t("about.emailCici")}`} className="hover:text-white transition-colors block">
                    {t("about.emailCici")}
                  </a>
                  <a href={`mailto:${t("about.emailJake")}`} className="hover:text-white transition-colors block">
                    {t("about.emailJake")}
                  </a>
                  <a href={`mailto:${t("about.emailJames")}`} className="hover:text-white transition-colors block">
                    {t("about.emailJames")}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Globe className="w-4 h-4 mt-1 flex-shrink-0" />
                <a 
                  href={`https://${t("about.website")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {t("about.website")}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>{t("about.address")}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="/" className="hover:text-white transition-colors">
                  {t("nav.home")}
                </a>
              </li>
              <li>
                <a href="/products" className="hover:text-white transition-colors">
                  {t("nav.products")}
                </a>
              </li>
              <li>
                <a href="/catalog" className="hover:text-white transition-colors">
                  {t("nav.catalog")}
                </a>
              </li>
              <li>
                <a 
                  href="/" 
                  onClick={(e) => {
                    e.preventDefault();
                    const aboutElement = document.getElementById('about');
                    if (aboutElement) {
                      aboutElement.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.location.href = '/';
                    }
                  }}
                  className="hover:text-white transition-colors"
                >
                  {t("nav.about")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}
